
import emptyImg from "@/assets/images/empty_img.png"

export default {
  name: "LazyImg",
  directives: {
    "lazy-load": {
      inserted(el, binding, vnode) {
        const observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                observer.disconnect()
                vnode.context.imgSrc = vnode.context.src
              }
            })
          },
          { threshold: 0 }
        )
        observer.observe(el)
      }
    }
  },
  props: {
    customStyle: {
      type: Object,
      default: () => ({})
    },
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String
    }
  },
  data() {
    return {
      imgSrc: emptyImg
    }
  },
  watch: {
    src(newVal) {
      this.imgSrc = newVal // 强制重新赋值以触发更新
    }
  }
}
